module.exports = __webpack_public_path__ + "img/2015-04_bloomberg.3ae8b8f7.jpg";